import { ApiStatusResponse } from '../types/types';
import { ApiRequestFailureError } from './errors';

export async function fetcher<T>(
  endpoint: string,
  init?: Record<string, any>
): Promise<T> {
  const req = await fetch(endpoint, init);
  const res = await req.json();

  if (!res || !res.status || res.status !== ApiStatusResponse.success) {
    throw new ApiRequestFailureError(endpoint, { res, init });
  }

  return res;
}
